(() => {
  const articles = document.querySelectorAll('[data-ion-signal-article]');

  articles.forEach((article) => {
    const progress = article.querySelector('[data-ion-reading-progress]');
    const content = article.querySelector('[data-ion-article-content]');

    if (!progress || !content) return;

    const updateProgress = () => {
      const contentRect = content.getBoundingClientRect();
      const contentTop = window.scrollY + contentRect.top;
      const contentHeight = Math.max(content.offsetHeight - window.innerHeight, 1);
      const current = Math.min(Math.max(window.scrollY - contentTop, 0), contentHeight);
      const percent = Math.round((current / contentHeight) * 100);

      progress.style.width = `${percent}%`;
      progress.parentElement?.setAttribute('aria-valuenow', String(percent));
    };

    updateProgress();
    window.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress, { passive: true });
  });
})();

